import { useState } from 'react';
import CourseSelect from "../../../Inputs/CourseSelect";
import modes from '../../../../config/modes.json';
import { TextField, Alert, MenuItem } from '@mui/material';
import Price from '../../../Inputs/Price';
import ModalForm from '../../../Tools/ModalForm';
import Toggle from '../../../Inputs/Toggle.js';
import moment from 'moment';
import API from '../../../../services/API.js';

export default function Form({person, onClose, onCreate, open}){

    const [data, setData] = useState({
        user: {id: person.id},
        course: {},
        type: {},
        amount: '',
        cashedAt: moment().format('YYYY-MM-DD')
    })

    const [error, setError] = useState(false)
    const [loading, setLoading] = useState(false);

    const handleChange = (key, val) => {
        let copy = {...data};
        copy[key] = val;
        return setData(copy);
    }

    const handleSubmit = e => {
        e.preventDefault();

        if( !isValid() ) return false;

        API.post(`/crm/enrollments`, data)
            .then(r => handleSuccess(r.data))
            .catch(e => handleError(e))

        return setLoading(true);
    }

    const handleSuccess = data => {
        console.log(data);
        setLoading(false);
        return onCreate(data);
    }

    const handleError = e => {
        console.log(e);
        setLoading(false);
        return setError("Une erreur s'est produite. Vérifier que l'utilisateur n'est pas déjà inscrit à cette formation.");
    }

    const isValid = () => {
        let e = false;
        if(!data.course.id) e = 'Veuillez sélectionner une formation.';
        if(Number.isNaN(data.amount)) e = 'Veuillez saisir un montant correct.';
        setError(e);
        return !e;
    }

    return <ModalForm open={open} loading={loading} onSubmit={handleSubmit} onClose={onClose} title='Inscription'>


            {error && <Alert severity='error'>{error}</Alert>}

            <CourseSelect 
                value={data.course?.id}
                onChange={id => handleChange('course', {id: id})}
            />

            <TextField 
                label="Mode d'inscription"
                value={data.type?.id || ''}
                onChange={e => handleChange('type', {id: e.target.value})}
                required={true}
                select
                size='small'
            >
                {modes.map(m =>
                    <MenuItem value={m.id} key={m.id}>{m.title}</MenuItem>    
                )}
            </TextField>
                
            <Price
                label="Montant payé"
                onChange={e => handleChange('amount', e.target.value)}
                value={data.amount}
                required={true}
            />

            <Toggle 
                label="Marquer comme encaissée"
                value={data.cashedAt !== null}
                onChange={() => 
                    handleChange('cashedAt', data.cashedAt ? null : moment().format('YYYY-MM-DD'))
                }
            />

            {(data.cashedAt !== null) &&

                <TextField 
                    label="Encaissée le"
                    value={data.cashedAt || ''}
                    onChange={e => handleChange('cashedAt', e.target.value)}
                    required={true}
                    size="small"
                    type="date"
                    InputLabelProps={{ shrink: true }}
                />
            }


    </ModalForm>
}